import React, { useState, useEffect } from 'react';
import axios from '../api/api';
import { toast } from 'sonner';
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { Link, useNavigate } from 'react-router-dom';
import logo from '../components/images/cf-logo-300x169.png'
import PropTypes from 'prop-types';

const Login = ({ setAccessToken }) => {

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();


  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const token = await axios.post('/auth/',
        { email, password }
      );
      setAccessToken(token);
      toast.success('Two Step Verification code sent to phone.');
      navigate('/2fa-login');
    } catch (error) {
      console.log(error);
      if (!error?.response) {
        toast.error('Network error! Check your connection.');
      } else if (error.response.status) {
        toast.error(error.response.data.detail)
      } else {
        toast.error('Oops! Something went wrong. Login failed.')
      }
    } finally {
      setLoading(false);
    }
  };

  const token_use = window.localStorage.getItem('token');
  const auth_token = JSON.parse(token_use)?.data.token_use;

  useEffect(() => {
    if (auth_token === 'bearer') {
      navigate('/app/dashboard')
    }
  }, [auth_token, navigate]);

  return (
    <main>
      <div className='flex flex-wrap items-center justify-center gap-4 h-screen md:h-screen lg:h-[100vh]'>
        <div className='bg-white p-4 rounded-lg w-full lg:w-1/3 2xl:w-1/4'>
          <form onSubmit={handleSubmit}>
            <div className='p-2'>
              <span><img src={logo} alt="logo" /></span>
              <h2 className='text-lg font-bold'>Welcome to Mawingu Airtime Corporate Portal</h2>
              <i>Powered by Mawingu airtime</i>
            </div>
            <div className='my-3'>
              <label htmlFor='email'><span>Email Address</span>
                <input
                  type='text'
                  required
                  placeholder='user@example.com'
                  className='px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-[#165277] focus:ring-[#165277] block w-full rounded-md sm:text-sm focus:ring-1'
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </label>
            </div>
            <div className="relative my-3">
              <label htmlFor="password" className="block">
                <span>Password</span>
                <div className="flex items-center">
                  <input
                    type={showPassword ? 'text' : 'password'}
                    required
                    placeholder="********"
                    className="px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-[#165277] focus:ring-[#165277] w-full rounded-md sm:text-sm focus:ring-1"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <button
                    type="button"
                    onClick={togglePasswordVisibility}
                    className="absolute right-3 text-sm text-[#165277] focus:outline-none"
                    style={{ top: '70%', transform: 'translateY(-50%)' }}
                  >
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                  </button>
                </div>
              </label>
            </div>
            <div className='my-2'>
              <button disabled={loading} className='bg-[#134463] text-white px-5 py-2 rounded-lg text-md w-full hover:bg-[#165277] disabled:bg-slate-500'>{loading ? 'Please Wait...' : 'Login'}</button>
            </div>
            <div>
              <h5>Don't have an account? <Link to='/register'><u className="hover:text-[#165277]">Register</u></Link></h5>
            </div>
            <div className='text-center mt-8'>
              <Link to='/forgot-password' className='text-red-600 hover:underline hover:text-[#165277]'>Forgot Password?</Link>
            </div>
          </form>
        </div>
      </div>
    </main>
  );
};

export default Login;

Login.propTypes = {
  setAccessToken: PropTypes.func
};
